<template>
        <div class="ad" draggable="false" >   
           <!--  <div v-if="cardsView"> -->
                <div  draggable="false" class="handCursor"  :class="{wobuCardInbox: $parent.isInbox, wobuCard: !$parent.isInbox, wobuOGCard: isOGshare, grayOut: grayOut, 'adHiddenImg': !$root.app.showImages}"  @click="navigate($event)"><!--  -->
                 <!--     <div v-show="isPush || isUpd" class="includeInPushWrapper">
                        <div>
                            <b class="is-size-7">&nbsp;Include:</b>&nbsp;<input type="checkbox" checked @click="toggleChecked" ref="checkBox">
                        </div>
                        </div> -->
                        <a  :href="item.url" target="_blank">
                    <div>
                       
                      <!--    <div class="is-size-7 has-background-black has-text-white has-text-centered colorLeft handCursor topRoundCorners" :class="{both: !$parent.$parent.showContext && !isSB && !isOGshare}">
                            <span>{{item.site}}</span>
                          
                        </div> -->
                        <div v-show="$root.app.showImages" class="cardImgContainer " :class="{cardImgContainerHeight: !collapsed && !isOGshare, cardImgContainerHeightOG: isOGshare}">
                            <img class="preventDrag" v-show="!collapsed && loaded" :src="item.img || defImg"  @load="imgHasLoaded" @error="imgError">
                            <img v-show="overlay && !collapsed" class="miimuDefOverlaySmall preventDrag"  :src="overlayImg"/>
                        </div>  
                    </div>
                     </a>
                    <div class="posRelative titCont">
    
                            <div v-show="!isOGshare" >
                                <div class="posRelative"  :class="{cardTitleBG: $root.app.showImages}">
                                    <div class="is-inline-block cardTitAndDesc"> <!-- style="width: 170px" -->
                                        <div class="cardTitle top5">{{item.title || '&nbsp;'}}</div>
                                         <div class="cardDescription">{{item.description || '&nbsp;'}}</div>
                                          <div class="cardDescription has-text-grey">{{item.site || '&nbsp;'}}</div>
                                    </div>
                               
    
                                    <div v-if="menuVisible" class="cardMenu has-text-left">
                                            <div class="bundleMenuItem" @click="openEdit($event)">
                                                <i class="fa fa-save is-size-6 handCursor sortControlButt"></i>Save
                                            </div>
                                            <div class="bundleMenuItem" @click="deleteAd($event)">
                                                <i class="fa fa-trash is-size-6 handCursor sortControlButt"></i>Delete
                                            </div> 
                                    </div> 
                
                                        <div class="is-inline-block vTop" @click.prevent="showMenu">
                                            <div class="cardVEllipsis"><b>&vellip;</b></div>
                                        </div>
                                 </div>
                            </div>

                         

                            <div v-show="isOGshare">
                                <div class="is-inline-block has-text-left pad5"> <!-- style="width: 170px" -->
                                    <div class="cardTitle is-size-6 top10">{{item.title || '&nbsp;'}}</div>
                                    <div class="top5 left5 is-size-7">{{item.description || '&nbsp;'}}</div>
                                    <div class="cardDescription has-text-grey top5">{{item.site || '&nbsp;'}}</div>
                                </div>

                                    <div class="top10 bottom20">
                                        <button class="button is-coolGreen is-small" @click="navigate">
                                            <b>Visit Link</b>
                                        </button>&nbsp;&nbsp;&nbsp;
                                     
                                  
                                        <button class="button is-coolGreen is-small" @click="openEdit()">
                                            <b>Save</b>
                                        </button> 
                                    </div>
                                   
                            </div> 
                            <div v-show="specific < 0"  class="sponsoredTitle" :class="{'bottom-10': !$root.app.showImages}">featured</div>
                    </div>
                </div>
                
               
                
               
        </div>

       
</template>

<script>

import { AZEventBus } from './AZEventBus'
import ads from '../static/ads'
import defImages from '../static/defimages'

export default {
    props: {
        cardInfo: Object,
        shareId: Number,
        sel: {
            type: Boolean,
            default: true
        },
        isPublic: {
            type: Boolean,
            default: false
        },
        inFeed: {
            type: Boolean,
            default: false
        },
        sponsored:{
            type: Boolean,
            default: false
        },
        collapsed: {
            type: Boolean,
            default: false
        },
        specific: {
            type: Number,
            default: -1
        }
    },

    data: function(){
        return {
            loaded: false,
            menuVisible: false,
            isPush: this.$parent.$parent.isPush,
            isUpd: this.$parent.$parent.upd,
            grayOut: false,
            isOGshare: false,
            isSB: false,
            overlayImg: '',
        }
    },

    mounted: function(){
        var self = this
        AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler)

         var observer = new IntersectionObserver(function(entries) {
        // isIntersecting is true when element and viewport are overlapping
        // isIntersecting is false when element and viewport don't overlap
        if(entries[0].isIntersecting === true){
            observer.disconnect()
            self.$root.app.logImpression(self.item.id)

        }
            
        }, { threshold: [0] });

        setTimeout(function(){ 
            // if(self.$refs.cardRef && self.$refs.cardRef[15])
                observer.observe(self.$el);
        }, 10)


        
    },

    beforeDestroy: function(){
        AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)
    },

    methods: {
        closeAllMenusHandler: function(msg){
            this.menuVisible = false
        },

        imgHasLoaded: function(){
            this.loaded = true;
            this.dragging = false;
            //remove
        },
        navigate: function(e){
            e.stopPropagation()
            this.$root.app.logAdClick(this.item.id)
            window.open(this.item.url);
        },
        showMenu: function(event){
            event.stopPropagation()
            this.menuVisible = true
        },
        openEdit: function(ev){
            ev.stopPropagation()
            if(!this.$root.app.isAuth){
                this.$root.app.showModalLogin()
                return
            }
            this.item.shareId = this.shareId
            this.$root.app.doShowModal('editModal', {cardPack: this.item, callApi: false})
        },
        imgError: function(){
            this.item.img = this.defImg
        },
        toggleChecked: function(){
            
            if(!this.grayOut){
                this.grayOut = true
                this.$parent.$parent.unInclude(this.item.id)
                //this.$refs.checkBox.attributes.checked = false
            } else {
                this.grayOut = false
                this.$parent.$parent.include(this.item.id)
                //this.$refs.checkBox.attributes.checked = true
            }
        },
        checkIt: function(){
            this.grayOut = false
            this.$parent.$parent.include(this.item.id)
            
        },
        uncheckIt: function(){
            this.grayOut = true
            this.$parent.$parent.unInclude(this.item.id)
            
        },

        deleteAd: function(ev){
            ev.stopPropagation()
            var self = this
            function w(d){
                if(d == 'ok'){
                    self.$root.app.showModalOK({message: "The ad has been deleted. It will not show next time you load Miimu."})
                }
                

            }

            function n(){

            }

            this.$root.app.apiClient.delete('subs/data/deletead', {adId : this.item.id}, w, n)
        }
    },
    computed: {
           item: { 


            get: function(){
           
                var temp = {url: ''}

                if(this.specific == -1)
                    var ite = az.getRandomInt(this.$root.app.ads.length)
                else
                    var ite = this.specific
                
                temp = this.$root.app.ads[ite]     

               
                
                //if(this.currImg != temp.img) this.loaded = false;
                return  temp || {title: '', site: '', cardsIndex: '', url: ''};
            }, 

           /*  set: function(newVal){

            } */
            
        },
        cardsIndex: {
            get: function(){
                return this.theCardsIndex
            },

            set: function(newVal){
               
            }   
        },
        defImg: function(){
            //return require('@/assets/img/miiMuDefault.jpg');
            return `${process.env.VUE_APP_IMAGE_BASE_URL}/m-ii-default.png`
        },
        overlay: function(){

            var temp2 = az.overlaySorter(this.item.site, this.item.url, this.item.img)
            this.overlayImg = defImages.overlays[temp2]
            return temp2
        },
        
    }    
}

</script>

<style scoped>

.preventDrag {
    user-drag: none;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

</style>